module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "boardroom_logo.144bf131.png";